(() => {
    if (window.__ajaxProductPageLoaded) return;
    window.__ajaxProductPageLoaded = true;
  
    const cache = new Map();
    const loadedScripts = new Set(
      [...document.scripts].map(s => s.src).filter(Boolean)
    );
  
    let loading = false;
  
    const getMain = (doc = document) =>
      doc.querySelector('#MainContent') ||
      doc.querySelector('main[role="main"]') ||
      doc.querySelector('main');
  
    const absUrl = url => new URL(url, location.origin).href;
  
    // 页面缓存 / 预加载
    function fetchPage(url) {
      url = absUrl(url);
  
      if (!cache.has(url)) {
        const request = fetch(url, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.text();
          })
          .catch(err => {
            cache.delete(url);
            throw err;
          });
  
        cache.set(url, request);
      }
  
      return cache.get(url);
    }
  
    // 更新 SEO / 页面标题
    function updateHead(nextDoc) {
      document.title = nextDoc.title;
  
      [
        ['link[rel="canonical"]', 'href'],
        ['meta[name="description"]', 'content'],
        ['meta[property="og:title"]', 'content'],
        ['meta[property="og:url"]', 'content'],
        ['meta[property="og:image"]', 'content']
      ].forEach(([selector, attr]) => {
        const current = document.querySelector(selector);
        const next = nextDoc.querySelector(selector);
  
        if (current && next) {
          current.setAttribute(attr, next.getAttribute(attr));
        }
      });
    }
  
    // 执行 AJAX 新插入的 script
    function activateScripts(root) {
      root.querySelectorAll('script').forEach(oldScript => {
        if (oldScript.src && loadedScripts.has(oldScript.src)) return;
  
        const script = document.createElement('script');
  
        [...oldScript.attributes].forEach(attr =>
          script.setAttribute(attr.name, attr.value)
        );
  
        script.textContent = oldScript.textContent;
        oldScript.replaceWith(script);
  
        if (script.src) loadedScripts.add(script.src);
      });
    }
  
    // 通知主题 / 自定义组件重新初始化
    function notifyLoaded(main) {
      main.querySelectorAll('[id^="shopify-section-"]').forEach(section => {
        section.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: {
            sectionId: section.id.replace('shopify-section-', '')
          }
        }));
      });
  
      document.dispatchEvent(new CustomEvent('product:ajax:loaded', {
        detail: { main }
      }));
    }
  
    // 无刷新切换产品
    async function loadProduct(url, pushState = true) {
      if (loading) return;
  
      const targetUrl = absUrl(url);
  
      // 正常点击当前产品时不重复加载
      // popstate 时必须允许重新加载
      if (pushState && targetUrl === absUrl(location.href)) return;
  
      loading = true;
      document.documentElement.classList.add('ajax-product-loading');
  
      const oldMain = getMain();
      const scrollY = window.scrollY;
  
      oldMain?.setAttribute('aria-busy', 'true');
  
      try {
        const html = await fetchPage(targetUrl);
        const nextDoc = new DOMParser().parseFromString(html, 'text/html');
        const nextMain = getMain(nextDoc);
  
        if (!oldMain || !nextMain) {
          throw new Error('MainContent not found');
        }
  
        const newMain = document.importNode(nextMain, true);
  
        oldMain.replaceWith(newMain);
  
        activateScripts(newMain);
        updateHead(nextDoc);
  
        if (pushState) {
          history.pushState({ ajaxProduct: true }, '', targetUrl);
        }
  
        notifyLoaded(newMain);
  
        requestAnimationFrame(() => window.scrollTo(0, scrollY));
  
      } catch (err) {
        console.error('[AJAX PRODUCT]', err);
  
      } finally {
        loading = false;
        document.documentElement.classList.remove('ajax-product-loading');
        getMain()?.removeAttribute('aria-busy');
      }
    }
  
    // 点击切换
    document.addEventListener('click', e => {
      const link = e.target.closest('[data-ajax-product]');
      if (!link) return;
  
      e.preventDefault();
  
      if (!link.classList.contains('is-active')) {
        loadProduct(link.href);
      }
    });
  
    // 浏览器后退 / 前进
    window.addEventListener('popstate', () => {
      loadProduct(location.href, false);
    });
  
    // 鼠标移上去提前加载
    document.addEventListener('mouseover', e => {
      const link = e.target.closest('[data-ajax-product]');
  
      if (link && !link.classList.contains('is-active')) {
        fetchPage(link.href).catch(() => {});
      }
    });
  
    // 当前页加入 history
    history.replaceState(
      { ...(history.state || {}), ajaxProduct: true },
      '',
      location.href
    );
  })();